import PropTypes from "prop-types"

import { Panel } from "areas/cart/components"
import Media from "components/ui/media"
import { IS_JEWLR } from "helpers/application"
import { freeGiftPromoEnabled } from "helpers/holiday"

import Help from "./help-footer"
import OrderSummary from "./order-summary"
import PromoCode from "./promo-code"

const SidePanel = ({ cartSummaryRef }) => {
  return (
    <>
      <OrderSummary cartSummaryRef={cartSummaryRef} />
      {freeGiftPromoEnabled() ? (
        <Media greaterThanOrEqual="tablet">
          <Panel className="tablet:py-24 pb-8">
            <PromoCode />
          </Panel>
        </Media>
      ) : (
        <Panel className="tablet:py-24 pb-8">
          <PromoCode />
        </Panel>
      )}
      {IS_JEWLR() && (
        <Media greaterThanOrEqual="tablet">
          <Help />
        </Media>
      )}
    </>
  )
}

SidePanel.propTypes = {
  cartSummaryRef: PropTypes.object,
}

export default SidePanel
